module.exports = __webpack_public_path__ + "static/media/goodyarnlogo.55a787f7.png";